<template>
  <div @click="openModal">
    <img v-if="payload.tags == undefined || payload.tags.length == 0" class="btn" src="/edit_icon.svg" width="24px">
    <div v-else>
      <p>{{ payload.tags }}</p>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  props: ['payload'],
  name: 'tags',
  methods: {
    openModal () {
      this.create({ designator: 'tags-modal', component_name: 'TagsForm', data: this.payload, modal_title: 'Tags' })
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
<style scoped>
.flex a {
  margin-left: 10px;
}
</style>
